import React, { useEffect, useCallback, useState} from 'react';
import GradientColorPicker from './GradientColorPicker.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import Dropdown from 'react-dropdown';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {WIDTH, HEIGHT, updatePlanarSize} from './constants.js';
import {connect} from 'react-redux';

const options = [
    {label: "240x160", value: {width: 240, height: 160}},
    {label: "300x200", value: {width: 300, height: 200}},
    {label: "600x400", value: {width: 600, height: 400}},
    {label: "900x600", value: {width: 900, height: 600}},
];
const LookConfig = ({effect, sequencerEngine}) => { 
    let [width, setWidth] = useState(WIDTH);
    let [height, setHeight] = useState(HEIGHT);

    let onChange = useCallback((e) => {
        let {width, height} = e.value;
        setWidth(width);
        setHeight(height);
        updatePlanarSize(width, height);
        effect.stop();
    }, [setWidth, setHeight]);
    return (
        <div className="look-config">
          <Dropdown
            className='osc-type-dropdown'
            options={options}
            onChange={onChange}
            value={options.find(o => o.value.width === width)}
            />
          <EffectParameterSlider
            name="Blur"
            unit="px"
            parameter={effect.blurParameter}
            min={0}
            max={40}
            step={1}
            lfoEnabled={true}
            isParameter={true}
            sequencerEngine={sequencerEngine}
          />
          <EffectParameterSlider
            name="Tension"
            parameter={effect.splineTensionParameter}
            root={3}
            min={0.5}
            max={400}
            step={0.01}
            lfoEnabled={true}
            isParameter={true}
            sequencerEngine={sequencerEngine}
          />
          <GradientColorPicker effect={effect}/>
       </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LookConfig);
